import React, { useState, useEffect } from 'react';
import ShowMoreArrow from '../Global/ShowMoreArrow';
//@ts-ignore
import * as styles from './filtered-content.module.css';
//@ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { KontentStringValue } from '../../../types/KontentProps';

interface Props {
    tags: { name: string; count: number }[];
    handleTagsClick: React.MouseEventHandler<HTMLButtonElement>;
    tagsClicked: string[];
    view_more_label?: KontentStringValue;
}

const TagSelector: React.FC<Props> = ({
    tags,
    tagsClicked,
    handleTagsClick,
    view_more_label,
}) => {
    const breakpoints = useBreakpoint();

    const truncatedTagsToShow = breakpoints.md ? 12 : 6;

    const [visibleTags, setVisibleTags] = useState(
        tags?.slice(0, truncatedTagsToShow)
    );

    useEffect(() => {
        setVisibleTags(tags?.slice(0, truncatedTagsToShow));
    }, [truncatedTagsToShow, tags]);

    const handleShowMoreTagsClick = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        setVisibleTags(tags);
    };

    const handleShowLessTagsClick = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        setVisibleTags(tags?.slice(0, truncatedTagsToShow));
    };

    const showMoreTagsButton = () => {
        if (tags.length > visibleTags.length) {
            return (
                <ShowMoreArrow
                    btnText={view_more_label?.value || 'Show More'}
                    strokeColor="#505251"
                    handleClick={handleShowMoreTagsClick}
                    transform={'0'}
                />
            );
        }

        if (
            tags.length > truncatedTagsToShow &&
            tags.length === visibleTags.length
        ) {
            return (
                <div className={styles.showLessArrow}>
                    <ShowMoreArrow
                        btnText={'Show less'}
                        strokeColor="#505251"
                        handleClick={handleShowLessTagsClick}
                        transform={'0'}
                    />
                </div>
            );
        }
    };

    const renderTags = (
        tag: { name: string; count: number },
        tagIdx: number
    ) => {
        let selectedTags = setSelectedTags(tagsClicked, tag.name);

        return (
            <button
                key={tagIdx}
                className={styles.tagButton}
                data-tag={tag.name}
                onClick={handleTagsClick}
                style={selectedTags}
            >
                {tag.name} ({tag.count})
            </button>
        );
    };

    return (
        <div className={styles.tagNames}>
            <div className={styles.tagCollection}>
                <button
                    className={styles.tagButton}
                    data-tag={''}
                    onClick={handleTagsClick}
                    style={
                        tagsClicked.length === 0
                            ? { background: '#f06623' }
                            : {}
                    }
                >
                    All
                </button>
                {visibleTags.map((tag, tagIdx) => {
                    return renderTags(tag, tagIdx);
                })}
            </div>

            {showMoreTagsButton()}
        </div>
    );
};

export default TagSelector;

function setSelectedTags(tagsClicked: any, tagName: string) {
    if (tagsClicked.includes(tagName)) {
        const selectedStyle: React.CSSProperties = {
            background: '#f06623',
        };
        return selectedStyle;
    } else {
        return {};
    }
}
